<mat-card appearance="outlined">
	<h1>Welcome to Kajimotmomusic!</h1>

	<p>This is a Progressive Web App built with Angular and Firebase.</p>
</mat-card>
